export default "__VITE_ASSET__uI6xcxRn__"